import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  container: (props: {aspectRatio?: number}) => ({
    display: 'flex',
    width: (props.aspectRatio >= 1) ? '100px' : '50px',
    height: (props.aspectRatio > 1) ? '50px' : '100px',
    alignItems: 'flex-start',
  }),
  columnContainer: (props: {aspectRatio?: number}) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  }),
  right50: (props: {aspectRatio?: number}) => ({
    display: 'flex',
    alignItems: 'flex-start',
    flex: '1 0 0',
    alignSelf: 'stretch',
    border: '1px solid var(--Sytetm-Divider, currentColor)',
    borderLeft: 'none',
  }),
  upperLeft25: (props: {aspectRatio?: number}) => ({
    display: 'flex',
    alignItems: 'flex-start',
    width: (props.aspectRatio >= 1) ? '50px' : '25px',
    height: (props.aspectRatio > 1) ? `${50 * (1/2)}px` : `${100 * (1/2)}px`,
    alignSelf: 'stretch',
    border: '1px solid var(--Sytetm-Divider, currentColor)',
    borderBottom: 'none',
  }),
  lowerLeft25: (props: {aspectRatio?: number}) => ({
    display: 'flex',
    alignItems: 'flex-start',
    height: (props.aspectRatio > 1) ? `${50 * (1/2)}px` : `${100 * (1/2)}px`,
    alignSelf: 'stretch',
    border: '1px solid var(--Sytetm-Divider, currentColor)',
  }),
  right50Selected: (props: {aspectRatio?: number}) => ({
    border: '2px solid var(--Sytetm-Divider, #1d93f3)',
    borderLeft: 'none',
  }),
  upperLeft25Selected: (props: {aspectRatio?: number}) => ({
    border: '2px solid var(--Sytetm-Divider, #1d93f3)',
    borderBottom: 'none',
  }),
  lowerLeft25Selected: (props: {aspectRatio?: number}) => ({
    border: '2px solid var(--Sytetm-Divider, #1d93f3)',
  }),
}));

export const Layout25To50To25Icon: FC<{isSelected: boolean; aspectRatio?: number}> = ({
  isSelected,
  aspectRatio,
}) => {
  const {
    container,
    columnContainer,
    right50,
    upperLeft25,
    lowerLeft25,
    right50Selected,
    upperLeft25Selected,
    lowerLeft25Selected,
  } = useStyles({ aspectRatio });

  const upperLeft25ClassName = classNames(upperLeft25, { [upperLeft25Selected]: isSelected });
  const lowerLeft25ClassName = classNames(lowerLeft25, { [lowerLeft25Selected]: isSelected });
  const right50ClassName = classNames(right50, { [right50Selected]: isSelected });

  return (
    <div className={container}>
        <div className={columnContainer}>
            <div className={upperLeft25ClassName} />
            <div className={lowerLeft25ClassName} />
        </div>
        <div className={right50ClassName} />
    </div>
  );
};
